import { HardcodedCardTypes } from "../components/Icon.js";
import { TRAVEL_TOKEN_TYPES } from "../server/api-types/WSSubsystemAccountTravelTokenDisplayFactory.js";
import { CARD_TYPE_CHARLIE } from "./Constants.js";

export const CARD_STATUS_PENDING = 'Pending';
export const CARD_STATUS_ACTIVE = 'Active';
export const CARD_STATUS_SUSPENDED = 'Suspended';
export const CARD_STATUS_CLOSED = 'Closed';

/**
 * Return time-sensitive string based on card status
 *
 * @param {Object} card - card to check
 */
export const getProductText = (card) => {
	if (card.status === CARD_STATUS_PENDING) {
		return 'Starts on ';
	} else if (card.status === CARD_STATUS_ACTIVE) {
		return 'Valid thru ';
	} else if (card.status === CARD_STATUS_SUSPENDED) {
		return 'Valid thru ';
	}
};

export const getCardType = ({
	tokenInfo,
	isMonochrome = false,
	mediaType = null,
}) => {

	if (tokenInfo?.tokenType === TRAVEL_TOKEN_TYPES.bankcard) {
		return isMonochrome ? `${tokenInfo.creditCardType}Inactive` : tokenInfo.creditCardType;
	}

	if (mediaType === TRAVEL_TOKEN_TYPES.openTransitTemporary && tokenInfo?.tokenType === CARD_TYPE_CHARLIE) {
		return TRAVEL_TOKEN_TYPES.openTransitTemporary;
	}
	else if (mediaType === TRAVEL_TOKEN_TYPES.openTransitRestricted) {
		// These are the HandsFree Icons
		return TRAVEL_TOKEN_TYPES.openTransitRestricted;
	}

	return isMonochrome ? HardcodedCardTypes.CharlieInactive : HardcodedCardTypes.CharlieCard;
};
